import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'welcome',
  template: `
      <div class="msg-center">
        <!--<span class="k-icon k-i-home"></span>
        <p>Bienvenido.</p>-->
      </div>`,
  styles: [`
    .msg-center {
      width: 100%;
      text-align: center;
    }
    .msg-center span,
    .msg-center p {
      color: #95a5a6;
    }
    .k-icon {
      font-size: 128px;
      margin: 30px;
    }
  `]  
})
export class WelcomeComponent implements OnInit {
  
  constructor() { }

  ngOnInit() { }

}